import { styled } from '@vebox/etui-system';
import { Div } from '@vebox/etui-system-elements';

const ControlRow = styled(Div)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export { ControlRow as C };
